import {api} from "./api";

export const pricingApi = {
  getPricing: async ({courseType, capacity, subject, pricings}) => {
    return api.pricingSvcRequest('GET', `/pricing/fees?courseType=${courseType}&capacity=${capacity}&subject=${subject}&pricings=${pricings.join(",")}`);
  }
};